import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import { MoodModel } from '../../../../models/Gen/BaseModels';
import { getSomeName } from '../../utils';

class DetailsView {
    constructor(params) {
        const data = ko.unwrap(params.data);

        this.feedback = data;

        this.parentClose = params.onClose;
        this.dateRange = params.dateRange;

        this.moods = ko.observableArray();
        this.moodsLoaded = ko.observable(false);

        this.selectedMoodsFeature = ko.observable();
        this.moodsPage = 1;
        this.pagesCount = 1;
        this.hasPages = ko.observable(false);

        this.detractorsCount = ko.observable();
        this.passivesCount = ko.observable();
        this.promotersCount = ko.observable();
        this.totalCount = ko.observable();
        this.nps = ko.observable('N/A');
        this.npsIsValid = ko.observable();

        this.requestMoods(ko.unwrap(params.selectedCat));
        this.requestNpsInfo(ko.unwrap(params.selectedCat));

        this.getSomeName = getSomeName;

        this.lineChartOptions = ko.observable();
        this.chartState = ko.observable('empty');
    }

    get dateRangeFrom() {
        const from = this.dateRange()[0];

        return from ? from.format(moment.HTML5_FMT.DATE) : null;
    }
    get dateRangeTo() {
        const from = this.dateRange()[1];

        return from ? from.format(moment.HTML5_FMT.DATE) : null;
    }

    twoDecimalPlacesIfCents(amount) {
        return (amount % 1 !== 0) ? amount.toFixed(2) : amount;
    }

    npsPercentOfTotal(obs) {
        return ko.computed(() => {
            const val = obs() || 0;

            if (!this.totalCount()) return 0;

            return (val / this.totalCount()) * 100;
        });
    }

    requestNpsInfo(cat) {
        $api.feedbacks.getNPSInfo(
            { projectCode: auth.project.UniqueCode, dateFrom: this.dateRangeFrom, dateTo: this.dateRangeTo, tag: cat },
            {},
            (resp) => {
                if (resp.isValid) {
                    this.detractorsCount(resp.detractorsCount);
                    this.passivesCount(resp.passivesCount);
                    this.promotersCount(resp.promotersCount);
                    this.totalCount(resp.totalCount);
                    this.nps(resp.nps);
                    this.npsIsValid(true);

                    const history = resp.history;

                    var strDates = Object.keys(history);

                    var vals = [];

                    for (var key of strDates) {
                        vals.push(history[key].nps);
                    }

                    if (vals.every(i => i === 0)) {
                        this.chartState('empty');
                    } else {
                        this.chartState('loading');
                    }

                    var xAxisCategories = strDates.map(i => new Date(i).toJSON());

                    this.lineChartOptions(constructChart(xAxisCategories, vals));
                } else {
                    this.npsIsValid(false);
                }
            }
        );
    }

    requestMoods(cat, add = false) {
        this.selectedMoodsFeature(cat);
        if (!add) this.moodsPage = 1;
        $api.feedbacks.getMoods(
            { projectCode: auth.project.UniqueCode, page: this.moodsPage, pageSize: 20, from: this.dateRangeFrom, to: this.dateRangeTo, tags: [cat] },
            {},
            (resp) => {
                const models = resp.items.map(i => new MoodModel(i));

                this.pagesCount = resp.pagesCount;
                this.moodsPage = resp.page;

                this.hasPages(this.moodsPage < this.pagesCount);

                if (!add) {
                    this.moods(models);
                } else {
                    ko.utils.arrayPushAll(this.moods, models);
                }
                this.moodsLoaded(true);
            }
        );
    }

    requestAnotherMoods() {
        this.moodsPage++;

        this.requestMoods(this.selectedMoodsFeature(), true);
    }


    closeItself() {
        this.parentClose();
    }
}

export default koComponent('adoption-detail-view', DetailsView);

function constructChart(labels, nps) {
    return {
        chart: {
            height: 280,
            type: 'line',
            fontFamily: 'Nunito',
            toolbar: { show: false },
            zoom: {
                enabled: false
            }
        },
        animations: {
            enabled: false
        },
        annotations: {
            yaxis: [
                {
                    y: 0,
                    borderColor: "rgba(0, 0, 0, 0.7)"
                }
            ]
        },
        colors: ['#3066BE'],
        stroke: {
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
                return val;
            },
            offsetY: 10,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            },
            enabled: false
        },
        series: [{
            name: 'NPS',
            data: nps
        }],
        xaxis: {
            categories: labels,
            type: 'datetime',
            position: 'bottom',
            labels: {
                offsetY: 0,
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            tooltip: {
                enabled: false,
                offsetY: -35,

            }
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            forceNiceScale: true,
            labels: {
                show: true,
                formatter: function (val, index) {
                    return val.toFixed(0);
                }
            },
            style: {
                fontWeight: 'bold'
            },
            min: -100,
            max: 100
        }
    };
}
